import { useMutation, UseQueryResult } from '@tanstack/react-query';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

import {
	updateKycFileStatus,
	UpdateKycFileStatusProps,
} from '@dealstack/frontend/shared/dataExchange/services/mip.service';

export const useUpdateKycFileStatus = (getKYCDataRequest: UseQueryResult) => {
	const mutation = useMutation<void, Error, UpdateKycFileStatusProps>({
		mutationFn: updateKycFileStatus,
	});

	const updateKycFileStatusWithHandling = async (data: UpdateKycFileStatusProps) => {
		mutation.mutate(data, {
			onSuccess: () => {
				void getKYCDataRequest.refetch();

				showToastV2({
					title: 'Updated',
					state: 'success',
				});
			},
		});
	};

	return {
		updateKycFileStatus: updateKycFileStatusWithHandling,
		mutation,
	};
};
